import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import RoleShell, { money } from "@/roleapps/RoleShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClientPortal() {
  const [projects, setProjects] = useState(null);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    axios.get(`${API}/portal/projects`).then((r) => setProjects(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Load failed"));
  }, []);
  useEffect(load, [load]);

  const approve = async (p) => {
    setBusy(p.id); setErr(""); setMsg("");
    try { await axios.post(`${API}/portal/approve-quote`, { project_id: p.id }); setMsg(`Quote approved for ${p.name}.`); load(); }
    catch (e) { setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Could not approve"); }
    finally { setBusy(""); }
  };

  return (
    <RoleShell mark="CL" title="My kitchen" subtitle="Client portal" testid="client-app">
      <h1 className="ra-h1">Your projects</h1>
      <p className="ra-h1sub">Track your kitchen, review quotes and approve them.</p>
      {err && <div className="ra-msg err">{err}</div>}
      {msg && <div className="ra-msg ok">{msg}</div>}
      {!projects ? <div className="ra-empty">Loading…</div> : projects.length === 0 ? (
        <div className="ra-card ra-empty">No projects linked to your account yet. Your dealer will share your kitchen here.</div>
      ) : (
        <div style={{ display: "grid", gap: 14, maxWidth: 680 }}>
          {projects.map((p) => {
            const q = p.quote;
            return (
              <div className="ra-card" key={p.id} data-testid={`portal-project-${p.id}`}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                  <h3 style={{ margin: 0, fontSize: 16 }}>{p.name}</h3>
                  <span className="ra-badge">{p.status}</span>
                </div>
                <div style={{ fontSize: 12.5, color: "#71717a", margin: "4px 0 10px" }}>{p.modules} modules</div>
                {!q ? <div style={{ fontSize: 13, color: "#71717a" }}>No quote yet.</div> : (
                  <>
                    <div className="ra-kv"><span>Quote</span><span>{q.number}</span></div>
                    <div className="ra-kv"><span>Subtotal</span><span>{money(q.subtotal)}</span></div>
                    <div className="ra-kv"><span>VAT</span><span>{money(q.tax)}</span></div>
                    <div className="ra-kv" style={{ fontWeight: 700 }}><span>Total</span><span>{money(q.total)}</span></div>
                    <div style={{ marginTop: 12 }}>
                      {q.status === "approved" ? (
                        <span className="ra-badge" style={{ background: "#f0fdf4", color: "#15803d" }} data-testid={`approved-${p.id}`}>Approved ✓</span>
                      ) : (
                        <button className="ra-btn" disabled={busy === p.id || !q.approvable} data-testid={`approve-${p.id}`} onClick={() => approve(p)}>
                          {q.approvable ? (busy === p.id ? "Approving…" : "Approve quote") : "Pending dealer review"}
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </RoleShell>
  );
}
